import { render, staticRenderFns } from "./TipoRegraSelector.vue?vue&type=template&id=8fa183da&scoped=true"
import script from "./TipoRegraSelector.vue?vue&type=script&lang=js"
export * from "./TipoRegraSelector.vue?vue&type=script&lang=js"
import style0 from "./TipoRegraSelector.vue?vue&type=style&index=0&id=8fa183da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa183da",
  null
  
)

export default component.exports